import { ChangeDetectionStrategy, Component } from '@angular/core';

import { APP_ROWS, DIAL_SEGMENTS } from '../../data/walkthrough.fixtures';

/**
 * Pane 6 / 8 — `Simplicity by design` (specs/auth.md §5.4).
 *
 * The only pane with FOUR bullets, and the only illustration containing a mock
 * of a compound control.
 *
 * ---------------------------------------------------------------------------
 * ⚠ THE TIER DIAL IS A PICTURE. §12 #17 REFUSES `kz-plan-bar` AND
 * `kz-capability-panel` / `kz-tier-segment` HERE BY NAME.
 *
 * Those are the real controls: they emit `(planSelect)` / `(tierSelect)` and
 * they change what a workspace can do. This pane is shown to somebody with no
 * workspace, no plan and no session. Rendering the real control would put a
 * live tier picker in front of a visitor and make a marketing claim look like a
 * setting — and the first time someone clicked it and nothing happened, the
 * pitch would have taught them the product is broken.
 *
 * So: three `<span>`s, one carrying an `on` class. No output, no signal, no
 * `role="radiogroup"`, nothing focusable. Same for the four app rows, which are
 * pictures of `kz-nav-row` / `kz-toggle-row` (§12 #18).
 * ---------------------------------------------------------------------------
 */
@Component({
  selector: 'app-walkthrough-pane6',
  standalone: false,
  templateUrl: './walkthrough-pane6.component.html',
  styleUrls: ['./walkthrough-pane6.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane6Component {
  readonly apps = APP_ROWS;
  readonly segments = DIAL_SEGMENTS;
}
